import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, Eye, Headphones, BookOpen, Mail, MessageSquare, Radio, Mic, Plus } from "lucide-react";
import { api } from "@/lib/api";

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-zinc-500" data-testid="dashboard-loading">Chargement…</div>;

  const cards = [
    ["Articles publiés", `${s.published} / ${s.articles}`, Newspaper, "/admin/articles"],
    ["Vues cumulées", s.views.toLocaleString("fr-FR"), Eye, "/admin/articles"],
    ["Podcasts", s.podcasts, Headphones, "/admin/podcasts"],
    ["Éditions magazine", s.magazines, BookOpen, "/admin/magazines"],
    ["Abonnés newsletter", s.subscribers, Mail, "/admin/abonnes"],
    ["Commentaires en attente", s.pending_comments, MessageSquare, "/admin/commentaires"],
    ["Flash infos actifs", s.ticker, Radio, "/admin/ticker"],
    ["Audios déposés à valider", s.pending_submissions, Mic, "/admin/podcasts"],
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-heading text-3xl font-black">Tableau de bord</h1><p className="text-zinc-500 text-sm">Vue d'ensemble de Chronique.cd</p></div>
        <Link to="/admin/articles?new=1" data-testid="dashboard-new-article-btn" className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2.5 text-xs font-bold uppercase tracking-wider hover:bg-red-700 transition-colors"><Plus size={16} /> Nouvel article</Link>
      </div>
      <div data-testid="admin-dashboard-stats" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map(([label, val, Icon, to], i) => (
          <Link to={to} key={label} data-testid={`stat-card-${i}`} className="bg-white border border-zinc-200 p-5 hover:border-red-600 transition-colors group">
            <div className="flex items-center justify-between"><span className="text-xs uppercase tracking-wider font-bold text-zinc-500">{label}</span><Icon size={18} className="text-red-600" /></div>
            <div className="font-heading text-3xl font-black mt-3 group-hover:text-red-600 transition-colors">{val}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
